module.exports = __webpack_public_path__ + "static/img/bg.655bbb3c.png";